import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import CurrencyCode from "./currencyCode";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SepaTransferPaymentResponse {
  @observable
  iban!: string;

  @observable
  swiftCode!: string;

  @observable
  qrCode!: string;

  @observable
  amount!: number;

  @observable
  counterpartyName!: string;

  @observable
  additionalInformation!: string;

  @observable
  currencyCode!: CurrencyCode;
}
